import React from 'react';
import Tooltip from '../../../modules/material-ui-kit/Tooltip/Tooltip';
import useStyles from './ToolbarStyles';
import Utils from '../../../services/UtilsService';

const ToolbarButton = (props) => {
    const {
        label,
        tooltip,
        active,
        style,
        onToggle,
    } = props;

    const classes = useStyles();

    const onButtonToggle = (e) => {
        e.preventDefault();
        onToggle(style);
    };

    let className = classes.button;

    if (active) {
        className = Utils.getClassName([className, 'active']);
    }

    return (
        <Tooltip title={tooltip} placement={'top'}>
            <span className={className} onClick={onButtonToggle} onMouseDown={(e) => e.preventDefault()}>
                {label}
            </span>
        </Tooltip>
    );
};

export default ToolbarButton;
